class HotspotProducts extends HTMLElement {
  constructor() {
    super();
    this.hotspots = this.querySelectorAll('.hotspot-point');
    this.slider = this.querySelector('product-slider');
    
    // Bind click events on hotspots
    this.hotspots.forEach((spot, index) => {
      spot.addEventListener('click', (e) => {
        e.preventDefault();
        this.activateHotspot(index);
      });
      // Also allow keyboard navigation
      spot.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.activateHotspot(index);
        }
      });
    });

    if (this.slider && this.slider.track) {
      // Sync hotspots when slider changes
      // Overriding snapToIndex to capture index changes reliably
      const ogSnap = this.slider.snapToIndex.bind(this.slider);
      this.slider.snapToIndex = (animate) => {
          ogSnap(animate);
          this.updateActiveHotspot(Math.round(this.slider.currentIndex));
      };
    }

    // Init first hot spot visual if any exist
    if (this.hotspots.length > 0) {
      this.updateActiveHotspot(0);
    }
  }

  activateHotspot(index) {
     if (this.slider) {
       this.slider.stopAutoplay();
       this.slider.currentIndex = index;
       this.slider.snapToIndex(true);
     } else {
       this.updateActiveHotspot(index);
     }
  }
  
  updateActiveHotspot(index) {
    this.hotspots.forEach((spot, i) => {
       spot.classList.toggle('is-active', i === index);
       spot.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }
}
customElements.define('hotspot-products', HotspotProducts);
